import writeExcelFile, { type SheetData } from "write-excel-file/browser";
import { formatDate } from "./calculations";
import {
	excelHeaderCell,
	excelNumberCell
} from "./invoiceAndReturnsExportData";
import type { ItemInfo } from "../models/item";

export const itemsExportHeaders = [
	"Item Name",
	"Date",
	"Purchase Price",
	"Sell Price",
	"Minimum Profit %",
	"Avl. Qty.",
	"Item Code"
];

export const prepareItemsExportData = (items: Record<string, ItemInfo>) => {
	const rows = Object.values(items).map((item) => [
		item.name,
		formatDate(item.createdAt),
		excelNumberCell(item.purchasePrice),
		excelNumberCell(item.sellPrice),
		excelNumberCell(item.minProfitPercent),
		excelNumberCell(item.availableQuantity),
		item.itemCode
	]);

	return {
		headers: itemsExportHeaders,
		rows
	};
};

export const exportItemsListToExcel = async (
	items: Record<string, ItemInfo>
) => {
	const { headers, rows } = prepareItemsExportData(items);
	const sheetData: SheetData = [headers.map(excelHeaderCell), ...rows];

	const timestamp = new Date().toISOString().slice(0, 10);

	await writeExcelFile(sheetData, {
		sheet: "Items List",
		stickyRowsCount: 1,
		columns: [
			{ width: 24 },
			{ width: 14 },
			{ width: 16 },
			{ width: 16 },
			{ width: 16 },
			{ width: 14 },
			{ width: 18 }
		]
	}).toFile(`items-list_${timestamp}.xlsx`);
};
